import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button } from '@ipc/ipc-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { deleteEdiRfidAuditRequestActionCreator } from '../redux/actions/EdiRfidAuditDeleteActions';
import { getCheckedRows } from '../../redux/selectors/EdiRfidAuditRequestListSelectors';

class EdiRfidAuditDeleteDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestIds: props.row.row.requestId,
    };
    this.confirmDelete = this.confirmDelete.bind(this);
  }

  confirmDelete() {
    if (this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0) {
      const requestsIdLists = [];
      this.props.checkedRows.forEach((row) => requestsIdLists.push(row.requestId));
      this.props.deleteEdiRfidAuditRequestActionCreator(
        requestsIdLists,
      );
    } else {
      this.props.deleteEdiRfidAuditRequestActionCreator(
        [this.state.requestIds],
      );
    }
    this.props.closeDialog();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Delete EDI-RFID Audit Request</DialogTitle>
        <div>
          <p style={{ padding: '5px' }}>Are you sure you want to delete EDI-RFID Audit request/s?</p>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmDelete}
            className="primary-button-false"
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

EdiRfidAuditDeleteDialog.propTypes = {
  row: PropTypes.objectOf(PropTypes.shape),
  deleteEdiRfidAuditRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  checkedRows: PropTypes.arrayOf(PropTypes.object),
};

function mapStateToProps(state) {
  return {
    checkedRows: getCheckedRows(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  deleteEdiRfidAuditRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EdiRfidAuditDeleteDialog);
